import { INFTStakeList } from '../models/INFTStake'
import { YetiSwapData } from './NFTCollections/YetiSwapData'
import { YTS } from '../../../constants'
import { ChainId, WAVAX } from '@yetiswap/sdk'
import { PenguinFinanceData } from './NFTCollections/PenguenFinance'
import { BraiNFTData } from './NFTCollections/BraiNftData'

// new Date(year, month, day, hours, minutes, seconds, milliseconds)

export const NFTStakeList: INFTStakeList[] = [
  {
    collection: YetiSwapData[0],
    contractAddress: '0x5c4b6986DD718C0A877385B9Fb6835e3159D9195',
    earnToken: YTS[ChainId.AVALANCHE],
    maxSupply: 300,
    rewardMultiplier: 1
  },
  {
    collection: PenguinFinanceData[5],
    contractAddress: '0xA95585A333C3CFaA486D9F35D1d4f8c57a5e6D31',
    earnToken: YTS[ChainId.AVALANCHE],
    maxSupply: 1500,
    rewardMultiplier: 1,
    finishAt: new Date(2022, 5, 8, 22, 0, 0)
  },
  {
    collection: BraiNFTData[0],
    contractAddress: '0x7781B6437871c0e07f0D954B43D3526CE39B0f96',
    earnToken: WAVAX[ChainId.AVALANCHE],
    maxSupply: 3333,
    rewardMultiplier: 1,
    //finishAt: new Date(2022, 5, 6, 21, 0, 0)
  }
]
